import { makeStyles, Text } from '@rneui/themed'
import { t } from 'app/i18l'
import { font } from 'app/theme'
import React from 'react'
import { View } from 'react-native'
import { Card } from 'shared/components/card'
import { RoundedButton } from 'shared/components/rounded-button'

interface Props {
  onGotoNextShifts(): void
  showNoShiftsCard?: boolean
  hasNonShiftEvents: boolean
}

export function EmptyDate({
  onGotoNextShifts,
  showNoShiftsCard,
  hasNonShiftEvents,
}: Props) {
  const styles = useStyles({ showNoShiftsCard, hasNonShiftEvents })

  return (
    <View style={styles.container}>
      {showNoShiftsCard ? (
        <NoShiftsCard onGotoNextShifts={onGotoNextShifts} />
      ) : hasNonShiftEvents ? null : (
        <NoShiftsText />
      )}
    </View>
  )
}

interface NoShiftsCardProps {
  onGotoNextShifts(): void
}

function NoShiftsCard({ onGotoNextShifts }: NoShiftsCardProps) {
  const styles = useStyles()

  return (
    <Card style={styles.card}>
      <View style={styles.cardContainer}>
        <Text style={styles.cardText}>{t('noScheduledShifts')}</Text>
        <Text style={styles.cardText}>{t('pickUpNextShifts')}</Text>

        <RoundedButton
          title={t('seeNextShifts')}
          emphasized
          onPress={onGotoNextShifts}
          containerStyle={styles.buttonContainer}
        />
      </View>
    </Card>
  )
}

function NoShiftsText() {
  const styles = useStyles()

  return <Text style={styles.noShiftsText}>{t('noShifts')}</Text>
}

export const getEmptyDateHeight = (
  hasNonShiftEvents: boolean,
  showNoShiftsCard?: boolean
) => (showNoShiftsCard ? 240 : hasNonShiftEvents ? 0 : 100)

interface StyleProps {
  showNoShiftsCard?: boolean
  hasNonShiftEvents: boolean
}

const useStyles = makeStyles((theme, props: StyleProps) => ({
  container: {
    height: getEmptyDateHeight(props.hasNonShiftEvents, props.showNoShiftsCard),
    justifyContent: 'center',
    padding: 10,
  },
  text: {
    fontSize: 17,
    fontFamily: font.bold,
    margin: 5,
  },
  card: {
    height: 200,
    backgroundColor: '#FBE2B9',
    margin: 10,
  },
  cardContainer: {
    flex: 1,
    justifyContent: 'space-between',
    padding: 5,
  },
  cardText: {
    fontSize: 17,
    fontFamily: font.bold,
    margin: 5,
    color: '#333333',
  },
  buttonContainer: {
    marginTop: 10,
  },
  noShiftsText: {
    fontSize: 20,
    textAlign: 'center',
  },
}))
